export const BANK_CODE: Record<string, string> = {
  국민은행: "004",
  신한은행: "088",
  하나은행: "081",
  우리은행: "020",
  농협은행: "011",
  기업은행: "003",
  카카오뱅크: "090",
  토스뱅크: "092",
  케이뱅크: "089",
  우체국: "071",
  새마을금고: "045",
  신협: "048",
  SC제일은행: "023",
  한국씨티은행: "027",
  대구은행: "031",
  부산은행: "032",
  광주은행: "034",
  전북은행: "037",
  경남은행: "039",
  제주은행: "035",
  수협은행: "007",
  지역농축협: "012",
  저축은행: "050",
  산림조합: "064",
  산업은행: "002",
  수출입은행: "008",
  한국은행: "001",
  // "기타 외국계은행": "051",
  // 모건스탠리은행: "052",
  // HSBC은행: "054",
  // 도이치은행: "055",
  // 제이피모간체이스은행: "057",
  // 미즈호은행: "058",
  // MUFG은행: "059",
  // BOA은행: "060",
  // 비엔피파리바은행: "061",
  // 중국공상은행: "062",
  // 중국은행: "063",
  // 대화은행: "065",
  // 교통은행: "066",
  // 중국건설은행: "067",
  // 대신저축은행: "102",
  // 에스비아이저축은행: "103",
  // 에이치케이저축은행: "104",
  // 웰컴저축은행: "105",
  // 신한저축은행: "106",
};

export const BANK_CODE_REVERSE: Record<string, string> = Object.entries(
  BANK_CODE
).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {} as Record<string, string>);
